import PopularProductPage from "../pages/PopularProduct";

const routesPopularProduct = [
  {
    path: "/popular/product",
    element: <PopularProductPage />,
  },
];

export default routesPopularProduct;
